export default __webpack_public_path__ + "static/media/image_2.75a28944.jpg";